export class HttpError extends Error {
    public name = 'HttpError';
    public code: number;
    constructor(response: any) {
        super(response.statusText);
        this.code = response.status;
    }
}
